module.exports = __webpack_public_path__ + "1813868cecfaa1b34a85293b1f1673e1.png";